// EmojiPicker.js
import React, { useEffect, useRef, useState } from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { EmojiIcon } from "@100mslive/react-icons";
import { Box, IconButton, Popover } from "@100mslive/roomkit-react";

const EmojiPicker = ({ onSelect, classes = "" }) => {
  const [showEmoji, setShowEmoji] = useState(false);
  const ref = useEmojiPickerStyles(showEmoji);

  return (
    <Popover.Root open={showEmoji} onOpenChange={setShowEmoji}>
      <Popover.Trigger asChild css={{ appearance: "none" }}>
        <IconButton as="div" className={classes}>
          <EmojiIcon />
        </IconButton>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          alignOffset={-40}
          sideOffset={16}
          align="end"
          css={{ p: 0 }}
        >
          <Box
            css={{
              minWidth: 352,
              minHeight: 435,
            }}
            ref={ref}
          >
            <Picker
              onEmojiSelect={onSelect}
              data={data}
              previewPosition="none"
              skinPosition="search"
            />
          </Box>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

const useEmojiPickerStyles = showing => {
  const ref = useRef(null);
  useEffect(() => {
    if (showing) {
      setTimeout(() => {
        const root = ref.current?.querySelector("em-emoji-picker").shadowRoot;
        const style = document.createElement("style");
        style.textContent = `
          #six-events-directory {
            --em-rgb-color: var(--hms-ui-colors-textPrimary);
            --em-rgb-input: var(--hms-ui-colors-textPrimary);
            --em-color-border: var(--hms-ui-colors-surface_default);
            --color-b: var(--hms-ui-colors-textPrimary);
            --rgb-background: transparent;
            color: var(--hms-ui-colors-textPrimary);
           } 
        `;
        root.appendChild(style);
      }, 0);
    }
  }, [showing]);

  return ref;
};

export default EmojiPicker;
